import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// Namespaces are loaded on demand from /public/locales (reused from the legacy
// front). fr is the fallback; the 3 supported UI languages are fr / en / nl.
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'nl'],
    debug: import.meta.env.DEV,
    // FR-first product (DESIGN.md §9): default to French; only an explicit
    // choice (persisted to localStorage) overrides it — we don't follow the
    // browser language so the UI doesn't silently switch to EN/NL.
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    ns: ['app'],
    defaultNS: 'app',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  })

export default i18n
